import { render, staticRenderFns } from "./UserCreatorWidgetSimpleV2.vue?vue&type=template&id=a2f9ea8c&scoped=true"
import script from "./UserCreatorWidgetSimpleV2.vue?vue&type=script&lang=js"
export * from "./UserCreatorWidgetSimpleV2.vue?vue&type=script&lang=js"
import style0 from "./UserCreatorWidgetSimpleV2.vue?vue&type=style&index=0&id=a2f9ea8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f9ea8c",
  null
  
)

export default component.exports